import { MarkerF } from '@react-google-maps/api'
import * as React from 'react'
import { useSnapshot } from 'valtio'
import { dayHistoryState } from '../../../../store/dayHistoryState.ts'
import { dataState } from '../../../../store/dataState.ts'
import { historyState } from '../../../../store/historyState.ts'
import { getPawIcon } from '../../../map/components/icons.ts'

/**
 * The animated pet marker for Day History mode.
 * Positioned at the current interpolated position from the store.
 * Shows gap indicators when the pet is in a gap period.
 */
export const DayHistoryMarker: React.FC = () => {
    const currentPosition = (useSnapshot(dayHistoryState) as typeof dayHistoryState).currentPosition
    const selectedPetId = (useSnapshot(historyState) as typeof historyState).selectedPetId
    const pets = (useSnapshot(dataState) as typeof dataState).pets

    const pet = pets.find(p => p._id === selectedPetId)

    if (!currentPosition || (currentPosition.lat === 0 && currentPosition.lng === 0)) {
        return null
    }

    const position = { lat: currentPosition.lat, lng: currentPosition.lng }
    const iconColor = pet?.iconColor || '#FF6B6B'

    return (
        <>
            <MarkerF
                position={position}
                icon={getPawIcon(iconColor, google)}
                opacity={currentPosition.inGap ? 0.5 : 1}
            />
        </>
    )
}
